<template>
  <li
    v-if="canViewVerticalNavMenuLink(item)"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      v-if="item.action"
      href="#"
      class="d-flex align-items-center"
      @click.prevent="handleClick"
      @click.native.stop="handleNativeClick"
    >
      <feather-icon v-if="item.icon" :icon="item.icon" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
    <b-link
      v-else
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <feather-icon v-if="item.icon" :icon="item.icon" />
      <span class="menu-title text-truncate">{{ t(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    const handleAction = () => {
      if (props.item.action === 'softphone') {
        window.open(
          'https://nexus-softphone.tubtimcrm.com',
          'softphone',
          'width=420,height=920,resizable=no,scrollbars=no,toolbar=no,menubar=no,location=no,status=no'
        )
      } else if (props.item.action === 'chat') {
        window.open('https://socialchat.tubtimcrm.com/', '_blank')
      } else if (typeof props.item.action === 'function') {
        props.item.action()
      }
    }

    const handleClick = () => {
      handleAction()
    }

    const handleNativeClick = () => {
      // Prevent default navigation
    }

    return {
      isActive,
      linkProps,
      updateIsActive,
      handleAction,
      handleClick,
      handleNativeClick,

      // ACL
      canViewVerticalNavMenuLink,

      // i18n
      t,
    }
  },

}
</script>
